export const appBar = {
  minHeight: '70px',
} as const
